import { Box, Input as ChakraInput } from "@chakra-ui/react"
import type { InputProps as ChakraInputProps } from "@chakra-ui/react"
import type { ReactNode } from "react"

interface InputGroupProps extends ChakraInputProps {
  startElement?: ReactNode
  endElement?: ReactNode
  w?: string | object
}

export const InputGroup = ({
  startElement,
  endElement,
  w,
  children,
  ...props
}: InputGroupProps) => {
  return (
    <Box position="relative" w={w || "100%"}>
      {startElement && (
        <Box
          position="absolute"
          left="12px"
          top="50%"
          transform="translateY(-50%)"
          zIndex={1}
          color="gray.500"
        >
          {startElement}
        </Box>
      )}
      {children || (
        <ChakraInput
          pl={startElement ? "40px" : undefined}
          pr={endElement ? "40px" : undefined}
          {...props}
        />
      )}
      {endElement && (
        <Box
          position="absolute"
          right="12px"
          top="50%"
          transform="translateY(-50%)"
          zIndex={1}
          color="gray.500"
        >
          {endElement}
        </Box>
      )}
    </Box>
  )
}

export default InputGroup
